"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
require("../../authentication/Models");
const feature_flags_service_1 = require("../../authentication/services/feature-flags.service");
const facility_service_1 = require("../../organisation/services/facility.service");
const feature_flags_enum_1 = require("../../common/enums/feature-flags.enum");
const windows_provider_1 = require("../../common/provider/windows.provider");
const i0 = require("@angular/core");
const i1 = require("../../organisation/services/facility.service");
const i2 = require("../../authentication/services/feature-flags.service");
const i3 = require("@angular/common");
const i4 = require("../../common/components/dnaR-checkbox/dnaR-checkbox.component");
function ToggleFeatureFlagsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "button", 9);
    i0.ɵɵlistener("click", function ToggleFeatureFlagsComponent_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.editFeatureFlags(); });
    i0.ɵɵtext(2, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ToggleFeatureFlagsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "button", 11);
    i0.ɵɵlistener("click", function ToggleFeatureFlagsComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.cancel(); });
    i0.ɵɵtext(2, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 12);
    i0.ɵɵlistener("click", function ToggleFeatureFlagsComponent_div_6_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.saveChanges(); });
    i0.ɵɵtext(4, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ToggleFeatureFlagsComponent_td_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "dnaR-checkbox", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r2.featureFlags.currentFacilityFeatureFlags.enableAgedCareAct2025)("isDisabled", true);
} }
function ToggleFeatureFlagsComponent_td_10_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "dnaR-checkbox", 14);
    i0.ɵɵlistener("onChecked", function ToggleFeatureFlagsComponent_td_10_Template_dnaR_checkbox_onChecked_1_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onToggleACAFlag($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r3.isAca2025Enabled);
} }
function ToggleFeatureFlagsComponent_td_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "dnaR-checkbox", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r4.featureFlags.currentFacilityFeatureFlags.enablePBRC)("isDisabled", true);
} }
function ToggleFeatureFlagsComponent_td_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "dnaR-checkbox", 14);
    i0.ɵɵlistener("onChecked", function ToggleFeatureFlagsComponent_td_15_Template_dnaR_checkbox_onChecked_1_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onTogglePBRCFlag($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r5.isPBRCEnabled);
} }
function ToggleFeatureFlagsComponent_td_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "dnaR-checkbox", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r6.featureFlags.currentFacilityFeatureFlags.enableDMF)("isDisabled", true);
} }
function ToggleFeatureFlagsComponent_td_20_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "dnaR-checkbox", 14);
    i0.ɵɵlistener("onChecked", function ToggleFeatureFlagsComponent_td_20_Template_dnaR_checkbox_onChecked_1_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.onToggleDMFFlag($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r7.isDMFEnabled);
} }
function ToggleFeatureFlagsComponent_td_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "dnaR-checkbox", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r8.featureFlags.currentFacilityFeatureFlags.enableSSO)("isDisabled", true);
} }
function ToggleFeatureFlagsComponent_td_25_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "dnaR-checkbox", 14);
    i0.ɵɵlistener("onChecked", function ToggleFeatureFlagsComponent_td_25_Template_dnaR_checkbox_onChecked_1_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.onToggleSSOFlag($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r9.isSSOEnabled);
} }
class ToggleFeatureFlagsComponent {
    constructor(facilityService, featureFlagsService, window) {
        this.facilityService = facilityService;
        this.featureFlagsService = featureFlagsService;
        this.window = window;
        this.featureFlags = {
            systemConfigurationFlags: {
                sendPensionerStatusOnAdmission: false,
                disableSendingExtraServiceToMedicare: false,
                enablePrivateResidents: false
            },
            currentFacilityFeatureFlags: {
                sendAdjustmentFundingJournalToTechone: false,
                sendExpectedFundingJournalToTechone: false,
                enableAgedCareAct2025: false,
                enablePBRC: false,
                enableDMF: false,
                enableSSO: false
            }
        };
        this.isViewMode = true;
        this.isAca2025Enabled = false;
        this.isPBRCEnabled = false;
        this.isDMFEnabled = false;
        this.isSSOEnabled = false;
    }
    ngOnInit() {
        this.featureFlagsService.getFeatureFlags().then((response) => {
            this.featureFlags = response;
        });
    }
    editFeatureFlags() {
        this.isViewMode = false;
        this.isAca2025Enabled = this.featureFlags.currentFacilityFeatureFlags.enableAgedCareAct2025;
        this.isPBRCEnabled = this.featureFlags.currentFacilityFeatureFlags.enablePBRC;
        this.isDMFEnabled = this.featureFlags.currentFacilityFeatureFlags.enableDMF;
        this.isSSOEnabled = this.featureFlags.currentFacilityFeatureFlags.enableSSO;
    }
    saveChanges() {
        this.facilityService.getSelectedFacility().then((selectedFacility) => __awaiter(this, void 0, void 0, function* () {
            yield this.featureFlagsService.setFeatureFlags(selectedFacility.id, feature_flags_enum_1.FeatureFlagsEnum.EnableAgedCareAct2025, this.isAca2025Enabled);
            yield this.featureFlagsService.setFeatureFlags(selectedFacility.id, feature_flags_enum_1.FeatureFlagsEnum.EnableDMF, this.isDMFEnabled);
            yield this.featureFlagsService.setFeatureFlags(selectedFacility.id, feature_flags_enum_1.FeatureFlagsEnum.EnablePBRC, this.isPBRCEnabled);
            yield this.featureFlagsService.setFeatureFlags(selectedFacility.id, feature_flags_enum_1.FeatureFlagsEnum.EnableSSO, this.isSSOEnabled);
            this.isViewMode = true;
            this.featureFlagsService.getFeatureFlags().then((response) => {
                this.featureFlags = response;
                this.window.location.reload();
            });
        }));
    }
    cancel() {
        this.isViewMode = true;
    }
    onToggleACAFlag(e) {
        this.isAca2025Enabled = !this.isAca2025Enabled;
    }
    onTogglePBRCFlag(e) {
        this.isPBRCEnabled = !this.isPBRCEnabled;
    }
    onToggleDMFFlag(e) {
        this.isDMFEnabled = !this.isDMFEnabled;
    }
    onToggleSSOFlag(e) {
        this.isSSOEnabled = !this.isSSOEnabled;
    }
}
exports.ToggleFeatureFlagsComponent = ToggleFeatureFlagsComponent;
ToggleFeatureFlagsComponent.ɵfac = function ToggleFeatureFlagsComponent_Factory(t) { return new (t || ToggleFeatureFlagsComponent)(i0.ɵɵdirectiveInject(i1.FacilityService), i0.ɵɵdirectiveInject(i2.FeatureFlagsService), i0.ɵɵdirectiveInject(windows_provider_1.WINDOW)); };
ToggleFeatureFlagsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ToggleFeatureFlagsComponent, selectors: [["toggle-feature-flags"]], decls: 28, vars: 10, consts: [[1, "col-xs-10", "col-xs-offset-1"], [1, "row"], [1, "feature-flags-header"], ["class", "col-xs-10 create-new-btn pull-right margin-top-20 edit-button-container", 4, "ngIf"], ["class", "col-xs-10 create-new-btn pull-right margin-top-20 edit-mode-buttons-container", 4, "ngIf"], [1, "table"], [1, "col-xs-12", "flags-row"], [4, "ngIf"], [1, "col-xs-10", "create-new-btn", "pull-right", "margin-top-20", "edit-button-container"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "col-xs-10", "create-new-btn", "pull-right", "margin-top-20", "edit-mode-buttons-container"], ["type", "button", 1, "btn", "btn-warning", "btn-lg", "cancel-button", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "save-button", 3, "click"], [3, "isChecked", "isDisabled"], [3, "isChecked", "onChecked"]], template: function ToggleFeatureFlagsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h1");
        i0.ɵɵtext(4, "Feature flag");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ToggleFeatureFlagsComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵtemplate(6, ToggleFeatureFlagsComponent_div_6_Template, 5, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "table", 5);
        i0.ɵɵelementStart(8, "tr", 6);
        i0.ɵɵtemplate(9, ToggleFeatureFlagsComponent_td_9_Template, 2, 2, "td", 7);
        i0.ɵɵtemplate(10, ToggleFeatureFlagsComponent_td_10_Template, 2, 1, "td", 7);
        i0.ɵɵelementStart(11, "td");
        i0.ɵɵtext(12, " ACA (Aged Care Act) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "tr", 6);
        i0.ɵɵtemplate(14, ToggleFeatureFlagsComponent_td_14_Template, 2, 2, "td", 7);
        i0.ɵɵtemplate(15, ToggleFeatureFlagsComponent_td_15_Template, 2, 1, "td", 7);
        i0.ɵɵelementStart(16, "td");
        i0.ɵɵtext(17, " PBRC (Powerbilling & revenue collection) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "tr", 6);
        i0.ɵɵtemplate(19, ToggleFeatureFlagsComponent_td_19_Template, 2, 2, "td", 7);
        i0.ɵɵtemplate(20, ToggleFeatureFlagsComponent_td_20_Template, 2, 1, "td", 7);
        i0.ɵɵelementStart(21, "td");
        i0.ɵɵtext(22, " DMF (Deferred management fee) ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "tr", 6);
        i0.ɵɵtemplate(24, ToggleFeatureFlagsComponent_td_24_Template, 2, 2, "td", 7);
        i0.ɵɵtemplate(25, ToggleFeatureFlagsComponent_td_25_Template, 2, 1, "td", 7);
        i0.ɵɵelementStart(26, "td");
        i0.ɵɵtext(27, " SSO configuration ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
    } }, directives: [i3.NgIf, i4.DnaRCheckbox], styles: [".feature-flags-header[_ngcontent-%COMP%] {\n  display: flex;\n  height: 102px;\n  padding: 30px 0px;\n  align-items: center;\n}\n.table[_ngcontent-%COMP%] {\n  display: table;\n}\n.flags-row[_ngcontent-%COMP%] {\n  width: inherit;\n  padding-left: 0px;\n  margin-left: -20px;\n}\n.edit-button-container[_ngcontent-%COMP%] {\n  padding-right: 0px;\n  margin-top: 10px;\n}\n.edit-mode-buttons-container[_ngcontent-%COMP%] {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0px;\n  margin-top: 10px;\n}\n.cancel-button[_ngcontent-%COMP%] {\n  margin-right: 4px;\n}\n.save-button[_ngcontent-%COMP%] {\n  margin-left: 4px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ToggleFeatureFlagsComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'toggle-feature-flags',
                templateUrl: './toggle-feature-flags.component.html',
                styleUrls: ['./toggle-feature-flags.component.less']
            }]
    }], function () { return [{ type: i1.FacilityService }, { type: i2.FeatureFlagsService }, { type: Window, decorators: [{
                type: core_1.Inject,
                args: [windows_provider_1.WINDOW]
            }] }]; }, null); })();
